import { render, staticRenderFns } from "./CentralStreetList.vue?vue&type=template&id=12335d9c&scoped=true&"
import script from "./CentralStreetList.vue?vue&type=script&lang=js&"
export * from "./CentralStreetList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12335d9c",
  null
  
)

export default component.exports